module.exports = __webpack_public_path__ + "static/media/Chapter4.583b7f38.pdf";